import React from 'react';
import { default as NextLink } from 'next/link';
import { CategoryFilterProps } from 'models/CategoryFilterProps';
import { buildHref } from 'helpers/buildHref';
import {
  Category as CategoryStyled,
  CategoryListItemLink
} from './CategoryFilter.styles';
import { getIconNameForCategoryId } from 'helpers/category-icon-mapper';
import { ButtonStyledCategory } from './CategoryFilter.styles';
import { allQueryParamsFalsy } from 'helpers/allQueryParamsFalsy';
import {
  colorsVariables,
  Context,
  Icon
} from '@trustedshops/tps-seo-shared-frontend-react-components';
import { addLineBreakOpportunity } from 'helpers/addLineBreakOpportunity';
import { iconVariables } from 'styles/icon.variables';
import { CATEGORY_BUTTON } from 'services/data-test-attributes';

const CategoryFilter = ({
  categoryList,
  activeFilters,
  keyword,
  styledAsButtons,
  title
}: CategoryFilterProps) => {
  const relDefinition =
    allQueryParamsFalsy({
      ...activeFilters,
      category: activeFilters.category,
      page: undefined
    }) &&
    !keyword &&
    !activeFilters.account
      ? 'follow'
      : 'nofollow';

  const categoryLinks =
    categoryList &&
    categoryList.map(({ id, name, urlPath, totalCount }) => {
      let icon: JSX.Element | string = getIconNameForCategoryId(id);
      if (icon !== '') {
        icon = (
          <Icon
            iconName={icon}
            iconSize={
              styledAsButtons ? iconVariables.SIZE_M : iconVariables.SIZE_S
            }
            color={colorsVariables.GRAY_700}
            lineHeight={iconVariables.LINE_HEIGHT_REGULAR}
          />
        );
      }

      const link = styledAsButtons ? (
        <NextLink
          data-category={urlPath}
          href={buildHref({
            ...activeFilters,
            account: undefined,
            category: urlPath,
            keyword: undefined,
            q: undefined,
            page: undefined
          })}
        >
          <ButtonStyledCategory $context={Context.Tertiary}>
            {icon}
            <div className="categoryName">{name}</div>
          </ButtonStyledCategory>
        </NextLink>
      ) : (
        <NextLink
          data-category={urlPath}
          href={buildHref({
            ...activeFilters,
            q: activeFilters.q || keyword,
            category: activeFilters.category === urlPath ? undefined : urlPath,
            keyword: undefined,
            page: undefined
          })}
          rel={relDefinition}
        >
          <CategoryListItemLink
            className={
              activeFilters.category === urlPath ? 'active' : undefined
            }
          >
            {icon}
            <div>
              <span className="categoryName">
                {addLineBreakOpportunity(name)}
              </span>
              <span className="totalCount">({totalCount})</span>
            </div>
          </CategoryListItemLink>
        </NextLink>
      );
      return (
        <li data-test={CATEGORY_BUTTON} key={id}>
          {link}
        </li>
      );
    });

  return (
    <>
      {title}
      <CategoryStyled>{categoryLinks}</CategoryStyled>
    </>
  );
};

export default CategoryFilter;
